import clsx from "clsx";
import Link from "next/link";
import type { ComponentProps } from "react";

import { MediaGalleryCarousel } from "@shared/ui/media-gallery-carousel";

import { Content } from "../components/content";
import type { PointCardData } from "../model";

import s from "./point-card.module.scss";

export type PointCardProps = ComponentProps<"article"> &
  PointCardData & {
    href?: string;
    clampDescriptionOnMobile?: boolean;
  };

export const PointCard = (props: PointCardProps) => {
  const { className, href, clampDescriptionOnMobile, ...data } = props;

  return (
    <article className={clsx(s.root, className, href && s.clickable)}>
      {href && (
        <Link
          href={href}
          className={s.overlayLink}
          aria-label={data?.title ?? undefined}
        >
          &nbsp;
        </Link>
      )}
      <Content
        data={data}
        clampDescriptionOnMobile={clampDescriptionOnMobile}
      />
      {(data?.photos?.length ?? 0) > 0 && (
        <div className={s.mediaLayer}>
          <MediaGalleryCarousel
            slides={data.photos ?? []}
            overlayIcon={data?.overlayIcon}
          />
        </div>
      )}
    </article>
  );
};

PointCard.displayName = "PointCard";
